import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { titlePlaceholder } from "../../../helpers/placeholders";
import { useSite } from "../../../hooks/SiteProvider";
import replacePlaceholders from "../../../helpers/replacePlaceholders";
import useRepeatableRepeater from "../../../hooks/draggables/useRepeatableRepeaterFieldProps";
import DraggableBox from "../DraggableBox";
const DraggableTitle = ({ item: { props, id, children }, elementId, ...rest }) => {
    const { textPlaceholders } = useSite();
    const Component = props?.component || "h1";
    const { value: repeatableRepeaterTextValue } = useRepeatableRepeater({
        type: "text",
        repeatableId: props?.repeatableRepeater,
        repeatableItemId: props?.repeatableRepeaterItem,
        identifier: props?.repeatableRepeaterText?.repeatableField,
    });
    const renderText = useCallback(() => {
        if (props?.repeatableRepeaterText?.type) {
            return repeatableRepeaterTextValue;
        }
        return (replacePlaceholders(props?.text, textPlaceholders) ||
            titlePlaceholder.value);
    }, [props?.text, textPlaceholders, repeatableRepeaterTextValue]);
    return (_jsx(Component, { className: props?.className || "font-heading text-4xl font-bold", "editor-key": id, "editor-text-type": props?.repeatableRepeaterText?.type, "editor-text-repeatable-field": props?.repeatableRepeaterText?.repeatableField, ...rest, children: children && children?.length > 0 ? (_jsx(DraggableBox, { itemId: id, elementId: elementId, childs: children || [], itemProps: props })) : (renderText()) }));
};
export default DraggableTitle;
//# sourceMappingURL=DraggableTitle.js.map